<template>
  <div class="flex items-center">
    <Icon
      v-for="n in 5"
      :key="`star-${n}`"
      name="MdiStar"
      class="block cursor-pointer"
      :class="[
        n <= modelValue ? 'text-warning-400' : 'text-gray-300',
        sizeClasslist,
      ]"
      :value="modelValue"
      @click="readonly ? null : $emit('update:modelValue', n)"
    />
  </div>
</template>

<script>
const sizes = {
  sm: "w-5 h-5",
  md: "w-8 h-8",
};
export default {
  props: {
    modelValue: {
      type: [Number],
      default: null,
    },
    readonly: {
      type: Boolean,
    },
    size: {
      type: String,
      default: "md",
    },
  },

  emits: ["update:modelValue"],

  computed: {
    sizeClasslist() {
      return sizes[this.size];
    },
  },
};
</script>
